import { render } from "./TabsContent.vue?vue&type=template&id=841d0640&ts=true"
import script from "./TabsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabsContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tabs/TabsContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "841d0640"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('841d0640', __exports__)) {
    api.reload('841d0640', __exports__)
  }
  
  module.hot.accept("./TabsContent.vue?vue&type=template&id=841d0640&ts=true", () => {
    api.rerender('841d0640', render)
  })

}


export default __exports__